function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "4.4c\\u2013-User-\\u2013-Library-\\u2013-Default-Overlay-option-2-Copy",
  transform: "translate(-941.000000, -639.000000)"
}, React.createElement("g", {
  id: "Group-5",
  transform: "translate(117.000000, 136.000000)"
}, React.createElement("g", {
  id: "Group-8",
  transform: "translate(28.000000, 38.000000)"
}, React.createElement("g", {
  id: "text-badge",
  transform: "translate(792.000000, 461.000000)"
}, React.createElement("g", {
  id: "Group-6"
}, React.createElement("rect", {
  id: "Rectangle",
  stroke: "#979797",
  fill: "#D8D8D8",
  opacity: 0,
  x: 0.5,
  y: 0.5,
  width: 24,
  height: 23
}), React.createElement("path", {
  d: "M20.2916666,4.00000011 L4.70833344,4.00000011 C4.52043835,3.99989745 4.34020761,4.07010238 4.2073457,4.19514889 C4.07448378,4.3201954 3.99989105,4.48982433 4.00000012,4.66666677 L4,6 C4.00000012,6.36818993 4.31713175,6.66666676 4.70833344,6.66666676 C5.09953514,6.66666676 5.41666677,6.36818993 5.41666677,6.0000001 L5.41666677,5.33333344 L11.7916667,5.33333344 L11.7916667,18.6666667 L10.375,18.6666667 C9.98379834,18.6666667 9.66666671,18.9651435 9.66666671,19.3333333 C9.66666671,19.7015232 9.98379834,20 10.375,20 L14.625,20 C15.0162017,20 15.3333333,19.7015232 15.3333333,19.3333333 C15.3333333,18.9651435 15.0162017,18.6666667 14.625,18.6666667 L13.2083333,18.6666667 L13.2083333,5.33333344 L19.5833332,5.33333344 L19.5833332,6.0000001 C19.5833332,6.36818993 19.9004649,6.66666676 20.2916666,6.66666676 C20.6828682,6.66666676 20.9999999,6.36818993 21,6 L20.9999999,4.66666677 C21.000109,4.48982433 20.9255162,4.3201954 20.7926543,4.19514889 C20.6597924,4.07010238 20.4795617,3.99989745 20.2916666,4.00000011 Z",
  id: "Path",
  fill: "#656363",
  fillRule: "nonzero"
})), React.createElement("g", {
  id: "Text-Badge",
  transform: "translate(4.000000, 4.000000)"
}))))));

var SvgTextBadge = function SvgTextBadge(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "17px",
    height: "16px",
    viewBox: "0 0 17 16",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTextBadge, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/text_badge.dc3a35e2.svg";
export { ForwardRef as ReactComponent };